export var NameInLegendOption;
(function (NameInLegendOption) {
    NameInLegendOption["name"] = "name";
    NameInLegendOption["ticker"] = "ticker";
    NameInLegendOption["nameAndTicker"] = "name_and_ticker";
})(NameInLegendOption || (NameInLegendOption = {}));
/**
 * Timerange for which data is displayed
 */
export var ChartDateZoom;
(function (ChartDateZoom) {
    ChartDateZoom["CHART_ZOOM_ONE_DAY"] = "1d";
    ChartDateZoom["CHART_ZOOM_FIVE_DAY"] = "5d";
    ChartDateZoom["CHART_ZOOM_TEN_DAY"] = "10d";
    ChartDateZoom["CHART_ZOOM_ONE_MONTH"] = "1m";
    ChartDateZoom["CHART_ZOOM_THREE_MONTH"] = "3m";
    ChartDateZoom["CHART_ZOOM_SIX_MONTH"] = "6m";
    ChartDateZoom["CHART_ZOOM_ONE_YEAR"] = "1";
    ChartDateZoom["CHART_ZOOM_THREE_YEAR"] = "3";
    ChartDateZoom["CHART_ZOOM_FIVE_YEAR"] = "5";
    ChartDateZoom["CHART_ZOOM_TEN_YEAR"] = "10";
    ChartDateZoom["CHART_ZOOM_YTD"] = "ytd";
    ChartDateZoom["CHART_ZOOM_MAX"] = "max";
})(ChartDateZoom || (ChartDateZoom = {}));
export var ChartSortColumn;
(function (ChartSortColumn) {
    ChartSortColumn["NAME"] = "name";
    ChartSortColumn["OWNER"] = "owner";
    ChartSortColumn["USER_MODIFY_DATE"] = "modify_date";
})(ChartSortColumn || (ChartSortColumn = {}));
export var ChartDropdownOption;
(function (ChartDropdownOption) {
    ChartDropdownOption["PREVIEW"] = "preview";
    ChartDropdownOption["SHARE"] = "share";
    ChartDropdownOption["RENAME"] = "rename";
    ChartDropdownOption["MOVE"] = "move";
    ChartDropdownOption["DELETE"] = "delete";
})(ChartDropdownOption || (ChartDropdownOption = {}));
